import React, { useState } from 'react'
import { Button, Icon, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

// The only way out of the DSP to a dynamic ad's URL (LATIN-2850). A dynamic ad is
// an HTML page we never render inside the portal, so every place that shows one
// mounts this instead of the media: a confirm step carrying the legend the card
// requires, and then the page in a new tab.
//
// `url` is the content's `file`, which for a dynamic ad IS the ad URL.
// `type` is the antd Button type, for callers that need it to read as something
// other than a plain inline link (e.g. floating over a preview).
const DynamicContentLink = ({ url, type = 'link' }) => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  const confirm = () => {
    setVisible(false)
    // noopener,noreferrer: the ad is third-party and must not reach window.opener.
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      <Button type={type} size="small" onClick={() => setVisible(true)}>
        <Icon type="link" /> {t('View content')}
      </Button>
      {/* A plain Modal, not Modal.confirm: the confirm dialog has its own look
          (alert icon, no title bar) and every modal in the platform uses this one. */}
      <Modal
        title={t('View content')}
        visible={visible}
        okText={t('View content')}
        cancelText={t('Cancel')}
        onOk={confirm}
        onCancel={() => setVisible(false)}
        // App.css zeroes .ant-modal-body globally, so every modal sets its own
        // padding. 21px is what UploadAdModal's holder uses.
        bodyStyle={{ padding: 21 }}
        destroyOnClose
      >
        {t(
          'Remember to view the content in a window with the resolution of the target screen(s). Some elements may look slightly different depending on the browser used. Only use URLs designed for this kind of use and coming from sources you trust.',
        )}
      </Modal>
    </>
  )
}

export default DynamicContentLink
